import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { PromocionesService } from '../../services/promociones.service';

@Component({
  selector: 'app-promo-grupo-form',
  templateUrl: './promo-grupo-form.component.html',
  styleUrls: ['./promo-grupo-form.component.css']
})
export class PromoGrupoFormComponent {

  agregarFormGrupo!: FormGroup;
  _grupo?: any;

  @Input()
  set grupo(data: any | undefined) {
    if (data) {
      this.agregarFormGrupo.patchValue(data);
      this._grupo = data;
    }
  }

  @Input()
  set idPromo(id: string) {
    this.agregarFormGrupo.get('id_promo').setValue(id);
  }

  @Output()
  back = new EventEmitter<void>();

  @Output()
  create = new EventEmitter<any>();

  constructor(
    private readonly formBuilder: FormBuilder
  ) {
    this.buildForm();
  }

  private buildForm() {
    this.agregarFormGrupo = this.formBuilder.group({
      id_promo: ['', []],
      id_grupo: ['', [Validators.required, Validators.maxLength(6), Validators.minLength(6)]],
      dsca_grupo: ['', []],
      cantidad: [null, [Validators.required]],
    })
  }

  accionesGrupo(event: string) {
    if (event === 'guardar') {
      this.create.emit(this.agregarFormGrupo.getRawValue());
    } else {
      this.back.emit();
    }
  }

}
